import { render, staticRenderFns } from "./b2.vue?vue&type=template&id=7f892724&scoped=true"
import script from "./b2.vue?vue&type=script&lang=js"
export * from "./b2.vue?vue&type=script&lang=js"
import style0 from "./b2.vue?vue&type=style&index=0&id=7f892724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f892724",
  null
  
)

export default component.exports